import { connect } from 'react-redux';

import decorate from '../../utils/decorate';

import { request, clear } from '../../modules/payments/actions/query';
import { request as getBonuses } from '../../modules/bonuses/actions/query-bonuses';
import PaymentSearch from './PaymentSearch.jsx';

function mapStateToProps(state) {
    return {
        status: state.payments.getIn([ 'collections', 'status' ]),
        bonusStatus: state.bonuses.getIn([ 'bonuses', 'status' ]),
        bonusList: state.bonuses.getIn([ 'bonuses', 'items' ]),
        payments: state.payments.get('items'),
        list: state.payments.getIn([ 'collections', 'items' ]),
        aggregations: state.payments.getIn([ 'collections', 'aggregations' ])
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onPaymentFormSubmit: data => dispatch(request(data)),
        onGetBonusTypes: () => dispatch(getBonuses()),
        onUnmount: () => dispatch(clear())
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    PaymentSearch
);
